import keyMirror from 'keymirror';

export const chatActionTypes = keyMirror({
	CLOSE_CHAT_INTERFACE: null,
	CLEAR_CHAT_SESSION: null,
	REFRESH_CHAT_INTERFACE: null,
	ADD_USER_MESSAGE: null,
	ADD_BOT_MESSAGE: null,
	PREPEND_CHAT_HISTORY_MESSAGES: null,
	REMOVE_BUTTONS_FROM_PREVIOUS_MESSAGE: null,

	OPEN_CHAT_INTERFACE_REQUEST: null,
	LOAD_MORE_CHAT_HISTORY_REQUEST: null,
	SEND_CHAT_MESSAGE_REQUEST: null,

	SET_CHAT_CONVERSATION_DATA: null,
	SET_CHAT_HISTORY_LOADING: null,
	SET_CHAT_SENDING: null,
	SET_CHAT_LAST_EVALUATED_KEY: null,
	SET_CHAT_MESSAGE_COUNTER: null,
	SET_CHAT_MESSAGE_OBJ: null,
	RESET_CHAT_MESSAGE_OBJ: null,
});
